import React from "react";
import { FormattedMessage } from "react-intl";

import { showValue } from "../../../../../../../components";

import "./DeviceCode.scss";

interface DeviceCodeProps {
  code?: string;
}

export const DeviceCode = ({ code }: DeviceCodeProps) => {
  return (
    <span className="device-code">
      <FormattedMessage id="code" />: {showValue(code)}
    </span>
  );
};
